import { TENANT_TYPES } from '../constants/tenant-types';
import * as ENGAGEMENT_TYPES from '../constants/engagement-types';
import * as UserUtils from './user-utils';
import t from '../translate';

const getEngagementTypes = tenantType => {
  switch (tenantType) {
    case TENANT_TYPES.MULTI_TENANT_MANAGEMENT:
    case TENANT_TYPES.CYBERINT_CUSTOMER:
      return [
        ENGAGEMENT_TYPES.ASM,
        ENGAGEMENT_TYPES.BRAND_ABUSE,
        ENGAGEMENT_TYPES.DARKWEB,
        ENGAGEMENT_TYPES.BRONZE,
        ENGAGEMENT_TYPES.SILVER,
        ENGAGEMENT_TYPES.GOLD,
        ENGAGEMENT_TYPES.PLATINUM
      ];
    case TENANT_TYPES.CYBERINT_PROVISIONING:
      return [
        ENGAGEMENT_TYPES.DEMO,
        ENGAGEMENT_TYPES.POC,
        ENGAGEMENT_TYPES.UNMANAGED_POC,
        ENGAGEMENT_TYPES.SIZING,
        ENGAGEMENT_TYPES.INTERNAL_USE
      ];
    case TENANT_TYPES.MSSP_PROVISIONING:
      return [ENGAGEMENT_TYPES.DEMO, ENGAGEMENT_TYPES.POC, ENGAGEMENT_TYPES.UNMANAGED_POC, ENGAGEMENT_TYPES.SIZING];
    case TENANT_TYPES.MSSP_MANAGEMENT:
      return [
        ENGAGEMENT_TYPES.MSSP_MGMT,
        ENGAGEMENT_TYPES.MSSP_MGMT_DEMO,
        ENGAGEMENT_TYPES.MSSP_MGMT_POC,
        ENGAGEMENT_TYPES.MSSP_MGMT_UNMANAGED_POC
      ];
    case TENANT_TYPES.CYBERINT_MANAGEMENT:
    case TENANT_TYPES.PARTNERS_VAR_MANAGEMENT:
      return [ENGAGEMENT_TYPES.INTERNAL_USE];
    case TENANT_TYPES.PARTNERS_VAR_PROVISIONING:
      return [ENGAGEMENT_TYPES.DEMO, ENGAGEMENT_TYPES.POC, ENGAGEMENT_TYPES.SIZING];
    case TENANT_TYPES.MSSP_REPORT:
      return [ENGAGEMENT_TYPES.REPORT];
    case TENANT_TYPES.MSSP_PARENT_ALLOCATION:
    case TENANT_TYPES.MSSP_STANDALONE_ALLOCATION:
      return [ENGAGEMENT_TYPES.PRODUCTION_CUSTOMER];
    default:
      return [];
  }
};

export const getOptions = tenantType => {
  const relevantTypes = getEngagementTypes(tenantType);
  return relevantTypes.map(type => ({ value: type, label: t(`engagement_types.${type}`) }));
};

export const isDarkweb = tenantOrEngType => {
  const type = tenantOrEngType?.[ENGAGEMENT_TYPES.ENGAGEMENT_TYPE_KEY] || tenantOrEngType;
  return [ENGAGEMENT_TYPES.DARKWEB, ENGAGEMENT_TYPES.BRAND_ABUSE].includes(type);
};

export const getDefaultEngType = ({ tenantType, engagementType, userInfo }) => {
  const isCyberintUser = UserUtils.isCyberintUser(userInfo);
  switch (tenantType) {
    case TENANT_TYPES.CYBERINT_MANAGEMENT:
    case TENANT_TYPES.PARTNERS_VAR_MANAGEMENT:
      return ENGAGEMENT_TYPES.INTERNAL_USE;
    case TENANT_TYPES.PARTNERS_VAR_PROVISIONING:
      // VAR admins (self-service, non-Cyberint) default to POC; a PSM picks from the visible dropdown.
      if (!isCyberintUser) return ENGAGEMENT_TYPES.POC;
      return engagementType;
    case TENANT_TYPES.MSSP_MANAGEMENT:
      return ENGAGEMENT_TYPES.MSSP_MGMT;
    case TENANT_TYPES.MSSP_REPORT:
      return ENGAGEMENT_TYPES.REPORT;
    case TENANT_TYPES.MSSP_STANDALONE_ALLOCATION:
    case TENANT_TYPES.MSSP_PARENT_ALLOCATION:
      return ENGAGEMENT_TYPES.PRODUCTION_CUSTOMER;
    case TENANT_TYPES.MSSP_PROVISIONING:
      if (!isCyberintUser) return ENGAGEMENT_TYPES.POC;
      return engagementType;
    case TENANT_TYPES.CYBERINT_CUSTOMER:
      // Multi Tenant admins have no engagement dropdown - the child inherits the parent tenant's type.
      if (UserUtils.isMultiTenantMgmtAdmin(userInfo)) return userInfo?.customer?.engagement_type;
      return engagementType;
    default:
      return engagementType;
  }
};

export const isTemEssentials = tenantOrEngType => {
  const type = tenantOrEngType?.[ENGAGEMENT_TYPES.ENGAGEMENT_TYPE_KEY] || tenantOrEngType;
  return type === ENGAGEMENT_TYPES.TEM_ESSENTIALS;
};
